import _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Cookies from "universal-cookie";
import "./App.scss";
import {
  getCreditLensPathPrefix,
  getEnv,
  isCreditLensFeatureEnabled
} from "./configState/selector";
import { WALKME_DEV_URL, WALKME_PROD_URL } from "./constants";
import Documents from "./documentList/Documents";
import EntityListView from "./entityList/EntityList";
import EntityView from "./entityView/EntityView";
import Footer from "./footer/footer";
import {
  getMetadataConfig,
  GetMetadataConfigActionType
} from "./metadata/actions";

import {
  getClientConfig,
  GetClientConfigActionType
} from "./clientMetadata/actions";
import Organizations from "./organizations/Organizations";
import {
  getSupportedLanguages,
  GetSupportedLanguagesActionType,
  getUserPreferences,
  GetUserPreferencesActionType
} from "./preferences/actions";
import AuthRoute from "./route/AuthRoute";
import DOMableComponent from "./route/DOMableComponent";
import { isUserAuthenticated } from "./route/selector";
import SideNav from "./sideNav/SideNav";
import SpreadContainer from "./spread/SpreadContainer";
import TopNav from "./topNav/TopNav";
import selectorsToProps from "./utils/selectorsToProps";

interface AppProps {
  isCreditLensFeatureEnabled: boolean;
  creditLensPathPrefix: string;
  getMetadataConfig: GetMetadataConfigActionType;
  getClientConfig: GetClientConfigActionType;
  getUserPreferences: GetUserPreferencesActionType;
  getSupportedLanguages: GetSupportedLanguagesActionType;
  isUserAuthenticated: boolean;
  env: string;
}
class App extends React.Component<AppProps> {
  public componentDidMount = async () => {
    if (this.props.isUserAuthenticated) {
      this.props.getMetadataConfig({ spreadId: "" });
      this.props.getUserPreferences();
      this.props.getSupportedLanguages();
      this.props.getClientConfig();

      const cookies = new Cookies();
      cookies.set("hasSignedIn", "true", {
        path: "/",
        expires: new Date(Date.now() + 99999999999999)
      });

      // @ts-ignore
      window._walkmeConfig = { smartLoad: true };
      (window as any).VERSION = "0.1.0";

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = this.walkmeUrl();
      document.body.prepend(script);
    }
  };

  public render() {
    return (
      <div className="App">
        <TopNav showUserMenu={!this.props.isCreditLensFeatureEnabled} />
        <div className="App__content-container">
          <SideNav />
          <div className="App__content">
            {this.props.isCreditLensFeatureEnabled
              ? this.getCreditLensRoutes()
              : this.getNormalRoutes()}
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  private getNormalRoutes() {
    return (
      <Switch>
        <AuthRoute exact={true} path="/spreads" component={Documents} />
        <AuthRoute
          path="/spreads/:id/:environmentName/:status/:route?"
          component={SpreadContainer}
        />
        <AuthRoute path="/entities" component={EntityListView} />
        <AuthRoute
          path="/entity/:id"
          component={DOMableComponent(EntityView)}
        />
        <AuthRoute
          exact={true}
          path="/organizations"
          component={Organizations}
        />
      </Switch>
    );
  }

  private getCreditLensRoutes() {
    return (
      <Switch>
        <Route
          path={`${this.props.creditLensPathPrefix}/spreads/:id/:route?`}
          component={SpreadContainer}
        />
      </Switch>
    );
  }

  private walkmeUrl() {
    if (_.includes(["dev", "qa"], this.props.env)) {
      return WALKME_DEV_URL;
    }

    if (_.includes(["staging", "prod"], this.props.env)) {
      return WALKME_PROD_URL;
    }

    return "";
  }
}

export default connect(
  selectorsToProps({
    isCreditLensFeatureEnabled,
    creditLensPathPrefix: getCreditLensPathPrefix,
    isUserAuthenticated,
    env: getEnv
  }),
  {
    getMetadataConfig: getMetadataConfig.action,
    getClientConfig: getClientConfig.action,
    getUserPreferences: getUserPreferences.action,
    getSupportedLanguages: getSupportedLanguages.action
  }
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx